import { render, staticRenderFns } from "./motRechazo.vue?vue&type=template&id=3200feb5&scoped=true&"
import script from "./motRechazo.vue?vue&type=script&lang=js&"
export * from "./motRechazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200feb5",
  null
  
)

export default component.exports